import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-b6e3202e")
const _hoisted_1 = { class: "plant-model-list-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.keyword,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_ctx.keyword = $event)),
        _ctx.onKeyChange
      ],
      class: "search-content",
      placeholder: "请输入搜索关键词"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_van_list, {
      class: "list",
      onLoad: _ctx.onLoad,
      offset: 10
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line",
            key: item.id,
            onClick: ($event: any) => (_ctx.onClickItem(item, index))
          }, [
            _createTextVNode(_toDisplayString(item.name) + " ", 1),
            (item.isSelect)
              ? (_openBlock(), _createBlock(_component_van_icon, {
                  key: 0,
                  name: "success",
                  size: "25",
                  class: "icons"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["onLoad"]),
    _createVNode(_component_van_button, {
      class: "bottom-btn",
      onClick: _ctx.onConfirm,
      round: "",
      type: "primary",
      block: ""
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}